import { Injectable } from '@angular/core';
import * as Parse from 'parse';
import { PhoneNumberPipe } from '../pipes/phone-number.pipe';
import { TitleCasePipe, UpperCasePipe } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

export interface IVendorInfo {
    companyName: string;
    contactName: string;
    phone: string;
    email: string;
    licenseNumber: string;
    type: string;
    type2?: string;
}

@Injectable()
export class VendorStateService {
    public loading: boolean = false;
    public saving: boolean = false;
    public lastSaved: Date | undefined;
    public deleting: boolean = false;
    public updating: boolean = false;
    public reload: boolean = false;
    public vendor: Parse.Object = new Parse.Object('Vendor');

    public vendorInfo: IVendorInfo = {
        companyName: '',
        contactName: '',
        phone: '',
        email: '',
        licenseNumber: '',
        type: '',
        type2: ''
    };

    public isVendorFormValid: boolean = false;
    public vendorFormValidity: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(
        private phonePipe: PhoneNumberPipe,
        private titleCasePipe: TitleCasePipe,
        private upperCasePipe: UpperCasePipe
    ) {
        this.vendorFormValidity.subscribe((isValid: boolean) => this.isVendorFormValid = isValid);
    }

    resetState() {
        this.resetVendorInfo();

        this.loading = false;
        this.saving = false;
        this.lastSaved = undefined;
        this.deleting = false;
        this.reload = false;
        this.vendor = new Parse.Object('Vendor');
    }

    hydrateVendorInfo() {
        this.vendorInfo = {
            companyName: this.titleCasePipe.transform(this.vendor.get('companyName') || ''),
            contactName: this.titleCasePipe.transform(this.vendor.get('contactName') || ''),
            phone: this.phonePipe.transform(this.vendor.get('user').get('phone') || ''),
            email: this.vendor.get('user').getUsername() || '',
            licenseNumber: this.vendor.get('licenseNumber') || '',
            type: this.vendor.get('type') || '',
            type2: this.vendor.get('type2') || ''
        };
    }

    resetVendorInfo() {
        this.vendorInfo = {
            companyName: '',
            contactName: '',
            phone: '',
            email: '',
            licenseNumber: '',
            type: '',
            type2: ''
        };
    }
}
